import { camelCase } from '../../shared/camel-case/camel-case.pipe';

export const getLotDescription = (description: string) => {
  switch (camelCase(description)) {
    case 'LotUpdatedByTaskGenerationLot': return 'Atualizado pela tarefa de geração de lotes';
    case 'LotUpdatedByTaskExportLot': return 'Atualizado pela tarefa de exportação de lotes';
    case 'LotUpdatedByRouteRegenerateLot': return 'Atualizado pela rota de regeração de lote';
    case 'LotUpdatedByRouteCloseLot': return 'Atualizado pela rota de fechamento de lote';
    case 'LotUpdatedByRouteExportLot': return 'Atualizado pela rota de exportação de lote';
    case 'LotUpdateClosedLot': return 'Atualizado para fechado';
    case 'LotUpdateToAutomatic': return 'Lote automático atualizado';
    case 'LotUpdateWithRemovingItems': return 'Lote atualizado com remoção de itens';
    case 'LotUpdateToStatusOpenAutomatic': return 'Atualização do status do lote para aberto';
    case 'LotNewCreateAutomatic': return 'Lote novo criado automáticamente';
    case 'LotCreateNewAutomatic': return 'Novo lote criado automáticamente';
    case 'LotDeletedManually': return 'Lote deletado manualmente';
    case 'LotExpiredClose': return 'Lote fechado por expiração';
    case 'LotDownload': return 'Lote baixado';
    case 'LotCreated': return 'Lote criado';
    default: return description;
  }
};
